import { NgModule } from '@angular/core';
import { RadioComponent } from './radio/radio';
import { IonicErrorHandler, IonicModule } from 'ionic-angular';
import { BotaoFacebookComponent } from './botao-facebook/botao-facebook';
import { BotaoTwitterComponent } from './botao-twitter/botao-twitter';
import { BlocoBotoesRedeSocialComponent } from './bloco-botoes-rede-social/bloco-botoes-rede-social';
import { MenuGeralComponent } from './menu-geral/menu-geral';
import { InputMensagemComponent } from './input-mensagem/input-mensagem';
import {AutosizeModule} from 'ngx-autosize';
import { AtalhoComponent } from './atalho/atalho';
import { ConversaUsuarioComponent } from './conversa-usuario/conversa-usuario';
import { ConversaAreaComponent } from './conversa-area/conversa-area';
import { ListaConversasComponent } from './lista-conversas/lista-conversas';

@NgModule({
	declarations: [RadioComponent,
    BotaoFacebookComponent,
    BotaoTwitterComponent,
    BlocoBotoesRedeSocialComponent,
    MenuGeralComponent,
    InputMensagemComponent,
    AtalhoComponent,
    ConversaUsuarioComponent,
    ConversaAreaComponent,
    ListaConversasComponent
    ],
	imports: [IonicModule.forRoot(ComponentsModule), AutosizeModule],
	exports: [RadioComponent,
    BotaoFacebookComponent,
    BotaoTwitterComponent,
    BlocoBotoesRedeSocialComponent,
    MenuGeralComponent,
    InputMensagemComponent,
    AtalhoComponent,
    ConversaUsuarioComponent,
    ConversaAreaComponent,
    ListaConversasComponent
    ]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts